import { isEmpty, isObjectLike, mapKeys, snakeCase, camelCase, pickBy, isNil, identity } from 'lodash';
import omitUndefinedProps from '../../utils/omitUndefinedProps';
import { toApiModel, toAppModel } from './questionOptionDataMapper';

export const allowedSurveyItemKeyList = [
  // List of allowed keys in survey item data model for contract compliance @sinslav
  'alignment',
  'backButton',
  'backgroundColor',
  'buttons',
  'clientUuid',
  'color',
  'commentsEnabled',
  'commentsLabel',
  'content',
  'count',
  'display',
  'formatValidationType',
  'itemList',
  'label',
  'labelAlignments',
  'labelEnabled',
  'labelLayout',
  'labelListEnd',
  'labelListEndMidpoint',
  'layout',
  'limit',
  'listStyle',
  'logic',
  'maximumCharacters',
  'midpointLabels',
  'enableFillColor',
  'numbering',
  'options',
  'personalLabelType',
  'plainText',
  'range',
  'remaining',
  'required',
  'section',
  'segment',
  'shape',
  'showIndex',
  'size',
  'startFromZero',
  'switchInputType',
  'textColor',
  'type',
  'url',
];

const isValuable = (val) => (isObjectLike(val) ? !isEmpty(val) : !isNil(val));

const getSurveyItemPredicate = (keyTransformer = identity) => (val, key) =>
  allowedSurveyItemKeyList.includes(keyTransformer(key)) && isValuable(val);

export const toAppBlockFormat = (surveyItemDataModel) => {
  const { back_button: backButton, options, ...restModel } = pickBy(
    surveyItemDataModel,
    getSurveyItemPredicate(camelCase),
  );

  return omitUndefinedProps({
    id: surveyItemDataModel.id,
    options: options ? options.map(toAppModel) : undefined, // property will be omitted in case of undefined @sinslav
    backButton: backButton ? toAppBlockFormat(backButton) : undefined, // property will be omitted in case of undefined @sinslav
    formatValidationType: surveyItemDataModel.validation_type,
    ...mapKeys(restModel, (val, key) => camelCase(key)),
  });
};

export const toApiBlockFormat = (surveyItemDataModel) => {
  const { backButton, options, formatValidationType, ...restBlock } = pickBy(
    surveyItemDataModel,
    getSurveyItemPredicate(),
  );
  return omitUndefinedProps({
    back_button: backButton ? toApiBlockFormat(backButton) : undefined, // property will be omitted in case of undefined @sinslav
    options: options ? options.map(toApiModel) : undefined, // property will be omitted in case of undefined @sinslav
    validation_type: formatValidationType,
    section_order: surveyItemDataModel.order, // section_order should only get out of App, not in @sinslav
    ...mapKeys(restBlock, (val, key) => snakeCase(key)),
  });
};
